import { makeAutoObservable } from "mobx"

interface Toaster {
    open: boolean;
    severity: "error" | "warning" | "info" | "success";
    message: string | null;
}

export default class ToasterStore {
    toast: Toaster = {
        open: false,
        severity: "info",
        message: null
    }

    constructor() {
        makeAutoObservable(this);
    }

    success = (content: string) => {
        this.toast.open = true;
        this.toast.severity = "success";
        this.toast.message = content;
    }

    error = (content: string) => {
        this.toast.open = true;
        this.toast.severity = "error";
        this.toast.message = content;
    }

    warning = (content: string) => {
        this.toast.open = true;
        this.toast.severity = "warning";
        this.toast.message = content;
    }

    info = (content: string) => {
        this.toast.open = true;
        this.toast.severity = "info";
        this.toast.message = content;
    }

    closeToaster = () => {
        this.toast.open = false;
        this.toast.message = null;
    }
}